const formatEventName = (eventName, namespace) => {
    if (namespace) {
        return `${namespace}.${eventName}`;
    }
    return eventName;
};
export { formatEventName };
